var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0352 18.1344C23.3546 15.7674 24.0143 14.584 25.0007 14.584C25.987 14.584 26.6467 15.7674 27.9661 18.1344L28.3075 18.7467C28.6824 19.4193 28.8699 19.7556 29.1622 19.9775C29.4545 20.1994 29.8185 20.2818 30.5466 20.4465L31.2095 20.5965C33.7716 21.1762 35.0527 21.4661 35.3575 22.4462C35.6623 23.4263 34.7889 24.4476 33.0422 26.4902L32.5903 27.0186C32.094 27.599 31.8458 27.8892 31.7341 28.2483C31.6225 28.6073 31.66 28.9945 31.735 29.7689L31.8034 30.474C32.0674 33.1992 32.1995 34.5618 31.4015 35.1675C30.6036 35.7733 29.4041 35.221 27.0052 34.1165L26.3845 33.8307C25.7028 33.5168 25.362 33.3599 25.0007 33.3599C24.6393 33.3599 24.2985 33.5168 23.6168 33.8307L22.9961 34.1165C20.5972 35.221 19.3977 35.7733 18.5998 35.1675C17.8018 34.5618 17.9339 33.1992 18.1979 30.474L18.2663 29.7689C18.3413 28.9945 18.3788 28.6073 18.2672 28.2483C18.1555 27.8892 17.9073 27.599 17.411 27.0186L16.9591 26.4902C15.2124 24.4476 14.339 23.4263 14.6438 22.4462C14.9486 21.4661 16.2297 21.1762 18.7918 20.5965L19.4547 20.4465C20.1828 20.2818 20.5468 20.1994 20.8391 19.9775C21.1314 19.7556 21.3189 19.4193 21.6938 18.7467L22.0352 18.1344Z",
    stroke: "#047DED",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.16602V8.33268",
    stroke: "#FF9502",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 41.666V45.8327",
    stroke: "#FF9502",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 25L8.33268 25",
    stroke: "#FF9502",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.666 25L45.8327 25",
    stroke: "#FF9502",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 37.5L13.2147 36.7853",
    stroke: "#047DED",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7852 13.2148L37.5003 12.4997",
    stroke: "#047DED",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 37.5L36.7853 36.7853",
    stroke: "#047DED",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2148 13.2148L12.4997 12.4997",
    stroke: "#047DED",
    strokeOpacity: 0.5,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.9f26f4a3336cb4c825bbb4fd1ecf8460.svg";
export { ForwardRef as ReactComponent };